import { QMASLazyDocument, Status } from 'app/modules/ui';
import { PRESET_CRITERIA_ITEM } from './constants';

export const DESCRIPTION_DEF = [
  {
    label: 'Product Description, Style & Color Progress',
    dataIndex: 'progress',
    render: (value: string) => {
      return value || 'N/A';
    }
  },
  {
    label: 'Signed Sample available',
    dataIndex: 'signedSampleAvailable',
    render: (value: string) => {
      if (value) {
        return value === 'yes' ? 'Yes' : 'No';
      }
      return 'N/A';
    }
  },
  {
    label: 'Appearance',
    dataIndex: 'appearance',
    render: (value: string) => {
      if (value) {
        const [label, color] = PRESET_CRITERIA_ITEM[value];
        return <Status type="text" value={label} color={color} />;
      }
      return value || 'N/A';
    }
  },
  {
    label: 'Accessories',
    dataIndex: 'accessories',
    render: (value: string) => {
      if (value) {
        const [label, color] = PRESET_CRITERIA_ITEM[value];
        return <Status type="text" value={label} color={color} />;
      }
      return value || 'N/A';
    }
  },
  {
    label: 'Material',
    dataIndex: 'material',
    render: (value: string) => {
      if (value) {
        const [label, color] = PRESET_CRITERIA_ITEM[value];
        return <Status type="text" value={label} color={color} />;
      }
      return value || 'N/A';
    }
  },
  {
    label: 'Package',
    dataIndex: 'package',
    render: (value: string) => {
      if (value) {
        const [label, color] = PRESET_CRITERIA_ITEM[value];
        return <Status type="text" value={label} color={color} />;
      }
      return value || 'N/A';
    }
  },
  {
    label: 'Labelling',
    dataIndex: 'labelling',
    render: (value: string) => {
      if (value) {
        const [label, color] = PRESET_CRITERIA_ITEM[value];
        return <Status type="text" value={label} color={color} />;
      }
      return value || 'N/A';
    }
  },
  {
    label: 'Reference Media',
    dataIndex: 'referenceMedia',
    className: 'reference-media',
    render: (value: any) => {
      if (Array.isArray(value)) {
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            {value.map((item) => {
              return (
                <QMASLazyDocument
                  key={item}
                  alt="attachments"
                  documentId={item}
                />
              );
            })}
          </div>
        );
      }
      return null;
    }
  }
];
